import React, { useReducer, useEffect } from "react";
import {
  HomeUnitInterface,
  SeniorInterface,
  SeniorsidentificationmanagerProps,
  SeniorsIdentificationReducer,
} from "./seniorsidentificationmanager.reducer";
import { BsXLg } from "react-icons/bs";
import Select from "react-select";
import "./styles.css";

export function Seniorsidentificationmanager({
  seniors,
  initialSeniorsSelected,
  setSeniorsSelected,
  homeUnits,
  text,
}: SeniorsidentificationmanagerProps) {
  const handleSeniorsToSelectList = (
    initialSeniorsSelected: SeniorInterface[]
  ) => {
    const initialSeniorIds = initialSeniorsSelected.map((senior) => senior.id);
    const filteredList = seniors.filter(
      (senior) => !initialSeniorIds.includes(senior.id)
    );
    return filteredList;
  };

  const initialState = {
    filter: initialSeniorsSelected.length > 0 ? true : false,
    homeUnitsSelected: [],
    seniorsToSelect:
      initialSeniorsSelected.length > 0
        ? handleSeniorsToSelectList(initialSeniorsSelected)
        : seniors,
    focusedSeniors:
      initialSeniorsSelected.length > 0 ? initialSeniorsSelected : [],
  };

  const [state, dispatch] = useReducer(
    SeniorsIdentificationReducer,
    initialState
  );

  useEffect(() => {
    setSeniorsSelected(
      state.focusedSeniors.map((senior: SeniorInterface) => senior.id)
    );
  }, [state.focusedSeniors]);

  const handleSeniorsListFilteredByHomeUnit = (
    seniors: SeniorInterface[],
    homeUnits: HomeUnitInterface[]
  ) => {
    const filteredSeniors = homeUnits.map((homeUnit: HomeUnitInterface) => {
      return {
        label: homeUnit.name,
        options: seniors.filter((senior) => senior.homeUnitId === homeUnit.id),
      };
    });
    return filteredSeniors;
  };

  return (
    <div id="sim">
      <h3>{text.seniors}</h3>
      <div>
        <input
          type="checkbox"
          id="noFilter"
          onChange={() => dispatch({ type: "SET_NO_FILTER", payload: false })}
          checked={!state.filter}
          className="sim-checkbox"
        />
        <label htmlFor="noFilter">{text.noSeniorSelected}</label>
      </div>
      <div>
        <input
          type="checkbox"
          id="seniorsFilter"
          onChange={() => dispatch({ type: "SET_FILTER", payload: seniors })}
          checked={state.filter}
          className="sim-checkbox"
          data-testid="seniorsFilter"
        />
        <label htmlFor="seniorsFilter">{text.warningSeniorFocused}</label>
      </div>
      {state.filter ? (
        <div className="sim-header-details">
          <p>{text.selectSenior} :</p>
          {homeUnits.length > 1 ? (
            <>
              <p className="meta">
                {text.filterBy} {text.homeUnit}:
              </p>
              {homeUnits.map((hu) => (
                <span key={hu.id}>
                  <input
                    type="checkbox"
                    id={`${hu.id}`}
                    onChange={() =>
                      dispatch({
                        type: "SET_HOME_UNIT",
                        payload: { seniors: seniors, homeUnit: hu.id },
                      })
                    }
                    checked={state.homeUnitsSelected.includes(hu.id)}
                    className="sim-checkbox"
                  />
                  <label htmlFor={`${hu.id}`} style={{ marginRight: "1rem" }}>
                    {hu.name}
                  </label>
                </span>
              ))}
            </>
          ) : null}
          {state.seniorsToSelect.length > 0 ? (
            <div style={{ marginTop: "1rem" }}>
              <Select
                placeholder={text.seniors}
                name="seniors"
                options={
                  homeUnits.length > 1
                    ? handleSeniorsListFilteredByHomeUnit(
                        state.seniorsToSelect,
                        homeUnits
                      )
                    : state.seniorsToSelect
                }
                className="react-select-container"
                classNamePrefix="react-select"
                onChange={(e) =>
                  dispatch({
                    type: "SET_SENIOR",
                    payload: { seniors: seniors, seniorSelected: e },
                  })
                }
                data-testid="react-select"
              />
            </div>
          ) : null}

          {state.focusedSeniors.length > 0 ? (
            <div style={{ marginTop: "1rem" }}>
              <p className="meta">{text.selectedSeniors} :</p>
              <ul className="seniors-identification-list">
                {state.focusedSeniors.map((senior: SeniorInterface) => (
                  <li key={senior.id} className="seniors-identification-tag">
                    {senior.name}
                    <BsXLg
                      className="seniors-identification-icon"
                      role="button"
                      data-testid="remove-senior"
                      onClick={() =>
                        dispatch({
                          type: "REMOVE_SENIOR",
                          payload: { seniors: seniors, seniorSelected: senior },
                        })
                      }
                    />
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <br />
          )}
        </div>
      ) : null}
      <br />
    </div>
  );
}

Seniorsidentificationmanager.defaultProps = {
  seniors: [
    {
      id: 1,
      name: "LEDOUX Germaine",
      homeUnitId: 1,
      value: 1,
      label: "LEDOUX Germaine",
    },
    {
      id: 2,
      name: "LEGENDRE Jean-Claude",
      homeUnitId: 1,
      value: 2,
      label: "LEGENDRE Jean-Claude",
    },
    {
      id: 3,
      name: "DOE John",
      homeUnitId: 2,
      value: 3,
      label: "DOE John",
    },
    {
      id: 4,
      name: "ROMEO Juliette",
      homeUnitId: 1,
      value: 4,
      label: "ROMEO Juliette",
    },
  ],
  initialSeniorsSelected: [
    {
      id: 1,
      name: "LEDOUX Germaine",
      homeUnitId: 1,
      value: 1,
      label: "LEDOUX Germaine",
    },
  ],
  homeUnits: [
    {
      id: 1,
      name: "EHPAD",
    },
    {
      id: 2,
      name: "Service Autonomie",
    },
  ],
  setSeniorsSelected: (e: number[]) => console.log(e),
  text: {
    senior: "Résident",
    seniors: "Les résidents",
    noSeniorSelected:
      "Aucun résident n'est sélectionné. Toutes les familles pourront consulter cet article.",
    warningSeniorFocused:
      "Seules les familles des résidents sélectionnés pourront consulter cet article.",
    selectSenior: "Sélectionnez un (ou plusieurs) résident(s)",
    homeUnit: "Service",
    filterBy: "Filtrer par",
    selectedSeniors: "Résidents sélectionnés",
  },
};
